import { Input, TextArea } from "components/inputs";
import styled, { css } from "styled-components";
import { breakpoints } from "theme/breakpoints";
import { ANIMATION_DURATION } from "../configs";

interface ContainerProps {
  isVisible: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  box-sizing: border-box;
  transition: opacity ${ANIMATION_DURATION};
  gap: 16px;

  span {
    opacity: unset;
    font-weight: unset;
  }

  .bottom-container {
    display: flex;
    justify-content: space-between;

    @media (max-width: ${breakpoints.sm}) {
      flex-direction: column;
    }
  }
`;

export const InputRow = styled.div`
  display: flex;
  gap: 16px;

  > input {
    width: 100%;

    :not(:last-child) {
      margin-right: 15px;
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    flex-direction: column;

    > input {
      width: unset;

      :not(:last-child) {
        margin-right: unset;
      }
    }
  }
`;

const inputStyle = css`
  flex: 1;
  box-sizing: border-box;
`;

export const StyledInput = styled(Input)`
  ${inputStyle}
`;

export const StyledTextArea = styled(TextArea)`
  ${inputStyle}
`;

export const ButtonsContainer = styled.div`
  display: flex;
  margin-top: 20px;
  align-self: flex-end;

  > button {
    align-self: center;
    padding: 0.4rem 1rem;
    min-width: 100px;

    :not(:last-child) {
      margin-right: 15px;
    }
  }
`;
